import React, {useEffect, useState} from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from "highcharts-react-official";
import './chart.css'

const mapData = require('../../assets/js/map.json')
require("highcharts/modules/map")(Highcharts);


const MapChart = (props) => {
    const {quarters, chartdata} = props
    const [option, setOption] = useState(null)
    const [calsses, setCalsses] = useState(null)
    const [width, setWidth] = useState(0)

    const color = ['rgba(124,181,236,0.3)',
        'rgba(90,200,90,0.3)',
        'rgba(240,190,50,0.3)',
        'rgba(244, 91, 91, 0.3)'
       ]

    const options = {
        spacingTop: 0,
        spacingBottom: 0,
        spacingLeft:0,
        spacingRight: 0,
        padding:0,
        margin:0,
        title: {
            text: "",
            style: {
                color: "#fff"
            }
        },

        chart: {
            backgroundColor: "transparent",
            type: "map",
            map: mapData,
            responsive: true,
            style: {
                fontFamily: 'iranyekan',
                fontsize: 14,
                fontWeight: 300,
                fontColor: "#fff",
                fill: "transparent",
                strokeWidth: 1,
                borderColor: "#999999"
            },
            align: "left",
        },

        mapNavigation: {
            enabled: false,
            enableButtons: false
        },
        credits: {
            enabled: false
        },
        colorAxis: {
            dataClasses: calsses
        },
        tooltip: {
            pointFormatter: function () {
                return this.name+': '+this.value;
            }
        },
        legend: {
            align: "left",
            verticalAlign: "bottom",
            floating: true,
            fontFamily: "iranyekan",
            layout: "vertical",
            valueDecimals: 0,
            backgroundColor:
            // theme
                (Highcharts.defaultOptions &&
                    Highcharts.defaultOptions.legend &&
                    Highcharts.defaultOptions.legend.backgroundColor) ||
                "rgba(240, 240, 240, 0.85)"
        },
        series: [
            {


                name: "iran",

                dataLabels: {

                    enabled: true,
                    color: "rgba(255,255,255,0.33)",
                    style: {
                        textTransform: "uppercase"
                    },
                    formatter() {
                        return this.point["name"]
                    }
                },
                tooltip: {
                    ySuffix: " %"
                },
                cursor: "pointer",
                joinBy: "postal-code",
                data: [],
                borderColor: '#888',
                borderWidth: 0.8,
                states: {
                    hover: {
                        color: '#96cafa',
                        borderColor: 'gray'
                    }
                },
                point: {}
            }
        ],
    }
    useEffect(()=>{
        let box = document.querySelector('.width');
        setWidth(box.clientWidth-80)
    })
    useEffect(() => {
        let calsses = [{
            from: 0,
            to: 1,
            color: "rgba(247,247,247)",
            name: "بدون آمار"
        }]
        quarters[0]?.values.map((q, i) => {
            calsses.push({
                from: q.from,
                color: color[i],
                name: q.title
            })
        })

        setCalsses(calsses)

    }, [quarters])


    useEffect(async () => {
        await mapData.features.map((data, i) => {
            var postalCode = data.properties["postal-code"];
            let value = 0;
            chartdata && chartdata.values.map((reportItem, index) => {
                if (reportItem.locationName === data.properties.name) {
                    value = +reportItem.value
                }
            })
            var name = data.properties.name;
            var type = value === 1 ? "widget name one" : "widget name two";
            var row = i;
            options.series[0].data.push({
                value: value,
                name: name,
                "postal-code": postalCode,
                row: row,
                type: type
            });
        })
        setTimeout(()=>{
            options.chart.width=width
            setOption(options)
        },100)
    }, [calsses,width])


    return (
        <HighchartsReact
            highcharts={Highcharts}
            constructorType={"mapChart"}
            options={option}
        />
    )
};

export default MapChart;